import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import showMsg from "@/utils/message";

import Layout from "@/views/layout/index.vue";

const Login = () => import("@/views/Login.vue");

export const constantRoutes = [
  { path: "/login/:color?", name: "login", component: Login, hidden: true },

  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "",
        component: () => import("@/views/index/index.vue"),
        name: "Home",
        meta: { title: "首页", icon: "el-icon-home1" },
      },
    ],
  },

  // {
  //   path: '/:catchAll(.*)',
  //   name: 'NotFound',
  //   hidden: true,
  //   component: () => import('@/views/NotFound.vue'),
  //   meta: { title: '404 Not Found' } // 设置页面标题为'404 Not Found'
  // }
];

// 权限路由
export const asyncRoutes = [
  // 考试项目
  {
    path: "/category",
    component: Layout,
    meta: {
      title: "考试分类",
      icon: "el-icon-fenlei",
    },
    children: [
      {
        path: "",
        component: () => import("@/views/category/index.vue"),
        meta: {
          title: "创建分类",
        },
      },
      {
        path: "topic",
        component: () => import("@/views/category/topicIndex.vue"),
        meta: {
          title: "题目分类",
        },
      },
      {
        path: "edit/:id(\\d+)",
        component: () => import("@/views/category/Edit.vue"),
        hidden: true,
        meta: {
          title: "编辑考试分类",
        },
      },
    ]
  },

  // 考试管理
  {
    path: "/exams",
    component: Layout,
    meta: {
      title: "考试管理",
      icon: "el-icon-wangshangchuti",
    },
    children: [
      {
        path: "",
        component: () => import("@/views/exams/index.vue"),
        meta: {
          title: "考试管理",
        },
      },
      {
        path: "add",
        component: () => import("@/views/exams/addExam/Add.vue"),
        hidden: true,
        meta: {
          title: "新增考试",
        },
      },
      {
        // /:is_formal/:exam_id(\\d+)/:is_new(\\d+)?
        path: "addExaminee/:exam_id(\\d+)",
        component: () => import("@/views/exams/addExam/addExaminee.vue"),
        hidden: true,
        meta: {
          title: "邀请考生",
        },
      },
      {
        path: "settings/:exam_id(\\d+)",
        component: () => import("@/views/exams/addExam/settings.vue"),
        hidden: true,
        meta: {
          title: "创建考试完成",
        },
      },
      {
        path: "finish/:exam_id(\\d+)",
        component: () => import("@/views/exams/addExam/finish.vue"),
        hidden: true,
        meta: {
          title: "创建考试完成",
        },
      },
      {
        path: "edit/:id(\\d+)",
        component: () => import("@/views/exams/Edit.vue"),
        hidden: true,
        meta: {
          title: "编辑考试信息",
        },
      },
      // 试题
      {
        // /:is_formal(\\d+)?/:exam_id(\\d+)/:is_new(\\d+)?
        path: "topic/:exam_id(\\d+)",
        component: () => import("@/views/exams/topic/index.vue"),
        hidden: true,
        meta: {
          title: "设计试题",
        },
      },
      // 人工审核
      {
        path: "manualaudit/:exam_id(\\d+)",
        component: () => import("@/views/exams/manualAudit.vue"),
        hidden: true,
        meta: {
          title: "人工审核",
        },
      },
      // 考生成绩
      {
        path: "score/:exam_id(\\d+)/:is_formal(\\d+)",
        component: () => import("@/views/exams/score/index.vue"),
        hidden: true,
        meta: {
          title: "考生成绩",
        },
      },
      {
        path: "score/info/:paper_id(\\d+)",
        component: () => import("@/views/exams/score/info.vue"),
        hidden: true,
        meta: {
          title: "考生成绩",
        },
      },
      {
        path: "score/history/:exam_id(\\d+)",
        component: () => import("@/views/exams/score/historyScore.vue"),
        hidden: true,
        meta: {
          title: "历史成绩",
        },
      },
      

      // 报名管理
      {
        path: "apply-manage",
        component: () => import("@/views/exams/applyManage.vue"),
        meta: {
          title: "报名管理",
        },
      },
      // 在线监控
      {
        path: "monitor",
        component: () => import("@/views/monitor/index.vue"),
        meta: {
          title: "在线监控",
        },
      },
    ],
  },
  // 试题管理
  {
    path: "/topic",
    component: Layout,
    meta: {
      title: "试题管理",
      icon: "el-icon-kaoshiguanli",
    },
    children: [
      {
        path: "",
        component: () => import("@/views/topic/index.vue"),
        meta: {
          title: "试题管理",
        },
      },
      {
        path: "edit/:id(\\d+)/:type(\\d+)?",
        component: () => import("@/views/topic/Edit.vue"),
        hidden: true,
        meta: {
          title: "编辑试题",
        },
      },

      // 试题模板
      {
        path: "template",
        name: "topicTemplate",
        component: () => import("@/views/topic/topicTemplate/index.vue"),
        meta: {
          title: "试题模板",
        },
      },
      {
        path: "template/edit-topics/:id(\\d+)",
        component: () => import("@/views/topic/topicTemplate/EditTopics.vue"),
        hidden: true,
        meta: {
          title: "编辑试题模板",
        },
      },
      // 试题
      {
        path: "template/design/:template_id(\\d+)",
        component: () => import("@/views/topic/topicTemplate/designTopics/index.vue"),
        hidden: true,
        meta: {
          title: "设计模板试题",
        },
      },

      // 批量上传列表
      {
        path: "uploadlist",
        name: "topicUpload",
        component: () => import("@/views/topic/UploadList.vue"),
        meta: {
          title: "试题导入列表",
        },
      },
    ],
  },
  {
    path: "/examinee",
    component: Layout,
    meta: {
      title: "考生管理",
      icon: "el-icon-user",
    },
    children: [
      {
        path: "",
        component: () => import("@/views/examinee/index.vue"),
        meta: {
          title: "考生管理",
        },
      },
      {
        path: "edit/:id(\\d+)",
        component: () => import("@/views/examinee/Edit.vue"),
        hidden: true,
        meta: {
          title: "考生信息",
        },
      },
      {
        path: "examination/:examinee_id(\\d+)",
        component: () => import("@/views/examinee/Examination.vue"),
        hidden: true,
        meta: {
          title: "考生所有考试",
        },
      },

      // 考生分类
      // {
      //   path: "category",
      //   component: () => import("@/views/examinee/examineeCate/index.vue"),
      //   meta: {
      //     title: "考生分类",
      //   },
      // },
      // {
      //   path: "category/edit/:id(\\d+)",
      //   component: () => import("@/views/examinee/examineeCate/Edit.vue"),
      //   hidden: true,
      //   meta: {
      //     title: "编辑考生分类",
      //   },
      // },

      // 批量上传列表
      {
        path: "uploadlist",
        name: "examineeUpload",
        component: () => import("@/views/examinee/UploadList.vue"),
        meta: {
          title: "考生导入列表",
        },
      },
    ],
  },
  {
    path: "/examTopic",
    component: Layout,
    hidden: true,
    meta: {
      title: "试题管理",
      icon: "el-icon-kaoshiguanli",
    },
    children: [
      {
        path: "mock",
        component: () => import("@/views/examTopic/mock/index.vue"),
        meta: {
          title: "模拟试题",
        },
        children: [
          {
            path: "add",
            component: () => import("@/views/examTopic/mock/Add.vue"),
            hidden: true,
            meta: {
              title: "新增模拟试题",
            },
          },
          {
            path: "edit/:id(\\d+)",
            component: () => import("@/views/examTopic/mock/Edit.vue"),
            hidden: true,
            meta: {
              title: "编辑模拟试题",
            },
          },
        ]
      },
      {
        path: "formal",
        component: () => import("@/views/examTopic/formal/index.vue"),
        meta: {
          title: "正式试题",
        },
        
        children: [
          {
            path: "add",
            component: () => import("@/views/examTopic/mock/Add.vue"),
            hidden: true,
            meta: {
              title: "新增正式试题",
            },
          },
          {
            path: "edit/:id(\\d+)",
            component: () => import("@/views/examTopic/mock/Edit.vue"),
            hidden: true,
            meta: {
              title: "编辑正式试题",
            },
          },
        ]
      },
    ],
  }, 
  {
    path: "/changepwd",
    component: Layout,
    meta: {
      title: "修改密码",
      icon: "el-icon-mima",
    },
    children: [
      {
        path: "",
        component: () => import("@/views/password/index.vue"),
        meta: {
          title: "修改密码",
          icon: "el-icon-mima",
        },
      },
    ]
  },

  // 访问不存在路由跳转到/
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];
const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes,
  base: '/'
});

// 白名单 name 值
const whiteList = ["login"];

// 添加权限路由
router.beforeEach(async (to, from, next) => {
  // 用户是否登录
  const debug = process.env.VUE_APP_DEBUG;
  const hasToken = store.getters.token;
  if (hasToken || debug == 1) {
    //已登录
    if (to.name === "login") {
      // 重定向至首页
      next({ path: "/" });
    } else {
      const hasAuth = store.getters.hasAuth;
      if(hasAuth){
        next();
      }else {
        try {
          store.dispatch("permission/generateRoutes");
          next({ ...to, replace: true });
        } catch (error) {
          // 重新登录
          await store.dispatch("user/resetToken");
          showMsg.error(error || "请重新登录");
          next(`/login?redirect=${to.path}`);
        }
      }
    }
  } else {
    // 未登录
    if (whiteList.includes(to.name)) {
      next();
    } else {
      console.log("未登录", to);
      next({ path: "/login", query: { redirect: to.path } });
    }
  }
});

export default router;
